export default __webpack_public_path__ + "static/media/Planet2.a9b40f8a.png";